// Button Text Declaration

import { NavEnd } from "./ButtonSet";

export const ButtonSetText = {
    login : "เข้าสู่ระบบ",
    search : "ค้นหา",
    confirm : "ยืนยัน",
    close : "ปิดหน้าต่าง",
    cancel : "ยกเลิก",
    clear : "ล้างข้อมูล",
    approved : "อนุมัติ",
    notapproved : "ไม่อนุมัติ",
    verified : "ตรวจสอบแล้ว",
    rejected : "ปฏิเสธ",
    add : "เพิ่มข้อมูล",
    edit : "แก้ไขข้อมูล",
    delete : "ลบข้อมูล",
    readmore : "อ่านเพิ่มเติม",
    back : "ย้อนกลับ",
    next : "ถัดไป",
    save : "บันทึก",
    send : "ส่งข้อมูล",
    download : "ดาวน์โหลด",
    upload : "ยืนยันการนำเข้าข้อมูล",
    exportexcel : "ส่งออกเป็น Excel",
    exportpdf : "ส่งออกเป็น PDF",
    exportword : "ส่งออกเป็น Word",
    submit : "ส่งข้อมูล",
    view : "ดูข้อมูล",
    print : "พิมพ์",
    navbegin : "<<",
    navprev : "<",
    navend : ">>",
    navnext : ">"
}